/**
 * Home page - Main landing page
 */

import {LandingLayout} from '../../components/layout/LandingLayout';
import {SEO} from '../../components/SEO';
import {Hero} from '../../components/landing/Hero';
import {TrustedBy} from '../../components/landing/TrustedBy';
import {Features} from '../../components/landing/Features';
import {HowItWorks} from '../../components/landing/HowItWorks';
import {Testimonials} from '../../components/landing/Testimonials';
import {PricingSection} from '../../components/landing/PricingSection';
import {FAQ} from '../../components/landing/FAQ';
import {FinalCTA} from '../../components/landing/FinalCTA';

export function HomePage() {
  return (
    <>
      <SEO
        title="VoxaPilot - AI-Powered Meeting Assistant"
        description="Transform your meetings with AI-powered transcription, intelligent summaries, and actionable insights. Record, transcribe, and analyze meetings automatically with VoxaPilot."
        keywords={[
          'meeting transcription',
          'AI meeting assistant',
          'meeting summaries',
          'voice to text',
          'meeting analytics',
          'Zoom transcription',
          'Teams transcription',
          'Google Meet transcription',
          'meeting notes',
          'automated transcription',
        ]}
      />
      <LandingLayout>
        <Hero />
        <TrustedBy />
        <Features />
        <HowItWorks />
        <Testimonials />
        <PricingSection />
        <FAQ />
        <FinalCTA />
      </LandingLayout>
    </>
  );
}

